import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { GetCompanyBankAccountIdsDocument } from './getCompanyBankAccountIds.gql';

const useMainBankAccountId = ({ skip = false } = {}) => {
  const { companyProfileId } = useCompanyContext();
  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useMainBankAccountId');
  }
  const { data, error, loading, refetch } = useQuery(
    GetCompanyBankAccountIdsDocument,
    {
      skip,
      variables: {
        companyProfileId,
      },
    },
  );
  // graphql only returns the main bank account id in this array
  // so we can be confident that the first element is the main bank account id
  const mainBankAccountId = data?.viewer?.bankAccountsIds?.[0];
  return {
    error,
    loading,
    mainBankAccountId,
    refetch,
  };
};

export default useMainBankAccountId;
